module.exports = __webpack_public_path__ + "static/img/banner-cursos-home-1680x1050.218eefd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/banner-cursos-home-1680x1050.jpg
// module id = 4spb
// module chunks = 47